import { cn } from "@/lib/utils";

export interface PasosProps {
  pasos: ReadonlyArray<string>;
  /** Indice del paso actual, desde 0. */
  actual: number;
  className?: string;
}

/**
 * Indicador de wizard: una barra fina por paso y "Paso N de M · titulo".
 * Barras y no circulos numerados con rotulo: cinco pasos entran en un
 * DialogHeader de 512px y cuatro entran en mobile. Los titulos de los otros
 * pasos quedan para el lector de pantalla.
 */
export function Pasos({ pasos, actual, className }: PasosProps): JSX.Element {
  return (
    <div className={cn("space-y-1.5", className)}>
      <p className="text-xs text-muted-foreground">
        Paso {actual + 1} de {pasos.length} ·{" "}
        <span className="font-medium text-foreground">{pasos[actual]}</span>
      </p>
      <ol aria-label="Pasos" className="flex gap-1.5">
        {pasos.map((paso, i) => (
          <li
            key={i}
            aria-current={i === actual ? "step" : undefined}
            className={cn(
              "h-1 flex-1 rounded-full transition-colors",
              i <= actual ? "bg-primary" : "bg-border",
            )}
          >
            <span className="sr-only">{paso}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
